import Country from "@/models/system/Country";
import Resource from "@/api/Resource";

class CountryApi extends Resource {
}

export default new CountryApi('countries', Country, null)